import { mapRecordsFromServer } from 'core/mappers';
import { partfinitiClient } from 'core/services';
import { IRequestPayload } from 'core/types';
import { getQueryStringToSnakeCase } from 'core/utils';
import {
  IAttachVendorQuotesPayload,
  ICorporateCostingProfileVendorQuote,
  IImportVendorQuotePayload,
} from 'corporate/types';

export const getVendorQuotes = async (requestPayload: IRequestPayload, signal?: AbortSignal) => {
  const { data } = await partfinitiClient.get(
    `/corporate_v2/costing-profile-vendor-quote-list/vendor-quotes?${getQueryStringToSnakeCase(
      requestPayload
    )}`,
    signal
  );

  return mapRecordsFromServer<ICorporateCostingProfileVendorQuote>(data.data, data.recordsFiltered);
};

export const detachVendorQuotes = async (data: { pricingProfileId: number; ids: number[] }) =>
  partfinitiClient.postForm('/corporate_v2/costing-profile-vendor-quote-edit/remove', data);

export const attachVendorQuotes = async (data: IAttachVendorQuotesPayload) =>
  partfinitiClient.postForm('/corporate_v2/costing-profile-vendor-quote-edit/save-bulk', data);

export const importVendorQuote = async (data: IImportVendorQuotePayload) =>
  partfinitiClient.postForm('/corporate_v2/costing-profile-vendor-quote-edit/import', data);
